// Presets filter by state, not invented state-to-ZIP boundaries.
const CONTIGUOUS = 'AL AZ AR CA CO CT DE FL GA ID IL IN IA KS KY LA ME MD MA MI MN MS MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI WY DC'.split(' ');
// Accept trailing zeros from historical Decimal strings without changing values.
const CENTS = /^(?:\d+(?:\.\d{0,2}0*)?|\.\d{1,2}0*)$/;
export const coveragePresets = [
  {id:'contiguous', fr:'48 États contigus + Washington, DC', en:'48 contiguous states + Washington, DC', states:CONTIGUOUS},
  {id:'ny', fr:'État de New York uniquement', en:'New York State only', states:['NY']},
  {id:'all_states', fr:'50 États + Washington, DC', en:'50 states + Washington, DC', states:[...CONTIGUOUS,'AK','HI']},
];
export function presetZone(id) {
  const preset = coveragePresets.find(p=>p.id===id);
  if (!preset) return null;
  return {name:preset.en, zip_from:'00000', zip_to:'99999', states:[...preset.states], bands:[{max_weight_lb:'',amount:''}]};
}
export function coverageLabel(zone,lang) {
  const preset = coveragePresets.find(p=>zone.zip_from==='00000' && zone.zip_to==='99999' &&
    [...zone.states].sort().join(',')===[...p.states].sort().join(','));
  return preset && (!zone.name || zone.name===preset.en) ? preset[lang] : zone.name || (lang==='fr'?'Zone personnalisée':'Custom zone');
}
export function gridIssue(grid, coverageOnly=false) {
  if (!grid?.zones?.length) return 'zones';
  const ranges=[];
  const states=new Set([...CONTIGUOUS,'AK','HI','PR','VI','GU','AS','MP','AA','AE','AP']);
  for (const z of grid.zones) {
    if (!/^\d{5}$/.test(z.zip_from) || !/^\d{5}$/.test(z.zip_to) || z.zip_from>z.zip_to ||
      !z.states?.length || z.states.some(s=>!states.has(s))) return 'zones';
    if (ranges.some(([a,b])=>z.zip_from<=b && z.zip_to>=a)) return 'overlap';
    ranges.push([z.zip_from,z.zip_to]);
    if (coverageOnly) continue;
    let lastWeight=0,lastPrice=0;
    if (!z.bands?.length) return 'prices';
    for (const b of z.bands) {
      const weight=Number(b.max_weight_lb), price=Number(b.amount);
      if (!Number.isFinite(weight) || weight<=lastWeight || weight>150 || !Number.isFinite(price) || price<=0 || price>10000 ||
          !CENTS.test(String(b.amount)) || price<lastPrice) return 'prices';
      lastWeight=weight;lastPrice=price;
    }
  }
  if (!coverageOnly && (!Number.isInteger(grid.max_units) || grid.max_units<1 || grid.max_units>100)) return 'units';
  return '';
}

export function policiesReady(cfg) {
  const m=cfg.safety_margin || {mode:'off',value:0};
  const validMoney=(v,max)=>v!=='' && v!=null && CENTS.test(String(v)) && Number(v)<=max;
  if (!['off','conditional','fixed','percent'].includes(m.mode) || !validMoney(m.value,m.mode==='percent'?100:1000)) return false;
  if (m.mode==='conditional' && !validMoney(m.threshold,1000000)) return false;
  return !cfg.free_enabled || (validMoney(cfg.free_threshold,Number.MAX_VALUE) && cfg.free_services.includes('automatic') && !cfg.free_states.length);
}
